module.exports = __webpack_public_path__ + "img/edit.1ee1abab.svg";